import '@/assets/global-styles.scss';
import '@/vendors/iFrameResizer';
import '@/vendors/ABN';
import App from './App.vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { i18n } from '@/i18n';
import iFrameResize from './vendors/iFrameResizer/lib/iFrameResize';
import { router } from './router';

const app = createApp(App);

app.use(createPinia());
app.use(i18n);
app.use(router);

// TODO (S.Panfilov) Causes [Vue warn]: A plugin must either be a function or an object with an "install" function.
app.use(iFrameResize);

app.mount('#app');
